// business.service.ts
import { inject, Injectable } from '@angular/core'
import { HttpClient, HttpParams } from '@angular/common/http'
import { Observable } from 'rxjs'
import { eps } from './url.service'
import { BusinessLogFilters, TaskLog } from '../store/task-log/task-log.state'

@Injectable({
  providedIn: 'root'
})
export class TaskLogService {
  private http = inject(HttpClient)
  private apiUrl = eps.tasklogs.tasklogsApi

  getMyTaskLogs(
    userId: string | null,
    page?: number,
    limit?: number
  ): Observable<{
    logs: TaskLog[]
    totalCount: number
  }> {
    const url = `${this.apiUrl}?&userId=${userId}&page=${page}&limit=${limit}`
    return this.http.get<{
      logs: TaskLog[]
      totalCount: number
    }>(url)
  }

  getBusinessTaskLogs(
    businessId: string,
    page: number,
    limit: number,
    filters: BusinessLogFilters
  ): Observable<{
    logs: TaskLog[]
    totalCount: number
  }> {
    let params = new HttpParams().set('businessId', businessId)
    params = params.set('page', page.toString())
    params = params.set('limit', limit.toString())

    if (filters.actorId) {
      params = params.set('actorId', filters.actorId)
    }
    if (filters.targetEntityId) {
      params = params.set('targetEntityId', filters.targetEntityId)
    }
    if (filters.isAuditLog !== undefined && filters.isAuditLog !== null) {
      params = params.set('isAuditLog', filters.isAuditLog.toString())
    }
    if (filters.searchQuery) {
      params = params.set('searchQuery', filters.searchQuery)
    }

    return this.http.get<{
      logs: TaskLog[]
      totalCount: number
    }>(`${this.apiUrl}/business`, { params })
  }
}
